// @flow
/**
 * The preceding flow comment must remain first in this file so that it is detected as supporting Flow. This is necessary
 * so that required files can also support Flow and it will pass through properly when imported into a web project.
 */

//TODO: refactor the 'dist' dependencies into something else (another repo maybe?)
var PageTitle = require('./dist/components/pageTitle.js');
var LoginPage = require('./dist/components/loginComponents/loginPage.js');
var Verification = require('./dist/components/loginComponents/verification.js');
var ValueProposition = require('./dist/components/loginComponents/valueProposition.js');
var SignUpPage = require('./dist/components/loginComponents/emailSignUp.js');
var SocialSignUpPage = require('./dist/components/loginComponents/socialSignUp.js');
var Modal = require('./dist/components/modal.js');
var Swipeable = require('./dist/components/Swipeable.js');
var FloatLabelField = require('./dist/components/FloatLabelField.js');
var ADAIconButton = require('./dist/components/AdaIconButton.js');
var TabSelector = require('./dist/components/tabSelector.js');
var PostalCodePage = require('./dist/components/loginComponents/postalCodePage.js');
var BackButtonBar = require('./dist/components/backButton.js');

//loyalty
var LoyaltySignUp = require('./dist/components/loginComponents/loyalty/loyaltySignUp.js');
var LoyaltyValueProp = require('./dist/components/loginComponents/loyalty/loyaltyValueProposition.js');
var YourNextRewardCard = require('./dist/components/loyalty/yourNextRewardCard.js');
var ChooseNextRewardComponent = require('./dist/components/loyalty/chooseNextRewardComponent.js');

//login
var EmailSignUpButton = require('./dist/components/loginComponents/SignUpButtons/Email/emailSignUpButton.js');
var FacebookSignUpButton = require('./dist/components/loginComponents/SignUpButtons/Facebook/facebookSignUpButton.js');
var GoogleSignUpButton = require('./dist/components/loginComponents/SignUpButtons/Google/googleSignUpButton.js');


var ListenerMixin = require('./dist/mixins/ListenerMixin');

var locationServiceClient = require('./dist/service_clients/locationServiceClient');
var loginServiceClient = require('./dist/service_clients/loginServiceClient');
var logoutServiceClient = require('./dist/service_clients/logoutServiceClient');
var menuServiceClient = require('./dist/service_clients/menuServiceClient');
var menuFavoriteServiceClient = require('./dist/service_clients/menuFavoriteServiceClient');
var profileServiceClient = require('./dist/service_clients/profileServiceClient');
var orderServiceClient = require('./dist/service_clients/orderServiceClient');
var offersServiceClient = require('./dist/service_clients/offersServiceClient');
var paymentServiceClient = require('./dist/service_clients/paymentServiceClient');
var passcodeServiceClient = require('./dist/service_clients/passcodeServiceClient');
var bootstrapProfileClient = require('./dist/service_clients/bootstrapProfileClient');
var careerJobServiceClient = require('./dist/service_clients/careerJobServiceClient');
var nutritionServiceClient = require('./dist/service_clients/nutritionServiceClient');
var loyaltyServiceClient = require('./dist/service_clients/loyaltyServiceClient');
var transactionHistoryServiceClient = require('./dist/service_clients/transactionHistoryServiceClient');
var autoReloadClient = require('./dist/service_clients/autoReloadClient');
var googleAnalyticsMeasurementProtocolServiceClient = require('./dist/service_clients/googleAnalyticsMeasurementProtocolServiceClient');
var emailVerificationServiceClient = require('./dist/service_clients/emailVerificationServiceClient');
var giftCardServiceClient = require('./dist/service_clients/giftCardServiceClient');

var storage = require('./dist/lib/storage');
var dispatcher = require('./dist/lib/flux/dispatcher');
var store = require('./dist/lib/flux/store');


module.exports = {
    // Deprecated
    components: {
        orderFunnelFooter: function () {
            return require('./dist/components/OrderFunnelFooter');
        },
        productTile: function () {
            return require('./dist/components/ProductTile/productTile').default;
        },
        productTileMobile: function () {
            return require('./dist/components/ProductTileMobile/productTileMobile').default;
        },
        rewardProductTile: function () {
            return require('./dist/components/RewardProductTile/rewardProductTile').default;
        },
        findLocationComponents: {
            searchContainer: function () {
                return require('./dist/components/findLocationComponents/search/SearchContainer');
            },
            findLocationDialog: function () {
                return require('./dist/components/findLocationComponents/Dialog');
            },
            mapCanvas: function () {
                return require('./dist/components/findLocationComponents/search/MapCanvas');
            }
        },
        locationsContainer: function () {
            return require('./dist/components/LocationsContainer').default;
        },
        map: function () {
            return require('./dist/components/Map').default;
        },
        mapComponents: {
            searchContainer: function() {
                return require('./dist/components/mapComponents/SearchContainer.js');
            },
            resultsContainer: function() {
                return require('./dist/components/mapComponents/ResultsContainer.js');
            },
            searchResult: function() {
                return require('./dist/components/mapComponents/SearchResult.js');
            }
        },
        loginComponents: {
            Verification: function() {
                return Verification;
            },
            ValueProposition: function() {
                return ValueProposition;
            },
            SignUpPage: function() {
                return SignUpPage;
            },
            SocialSignUpPage: function () {
                return SocialSignUpPage;
            },
            PostalCodePage: function () {
                return PostalCodePage;
            },
            LoginPage: function() {
                return LoginPage
            },
            loyaltySignUp: function () {
                return LoyaltySignUp;
            },
            loyaltyValueProposition: function () {
                return LoyaltyValueProp;
            },
            emailSignUpButton: function () {
                return EmailSignUpButton;
            },
            googleSignUpButton: function () {
                return GoogleSignUpButton;
            },
            facebookSignUpButton: function () {
                return FacebookSignUpButton;
            },
        },
        genericComponents: {
            floatLabelField: function() {
                return FloatLabelField
            },
            modal: function() {
                return Modal;
            },
            image: function() {
                return require('./dist/components/Image/image').default;
            },
            swipeable: function() {
                return Swipeable;
            },
            genericDropDown: require('./dist/components/GenericDropDown'),
            ADAIconButton: function() {
                return ADAIconButton
            },
            pagetitle: function() {
                return PageTitle.default
            },
            tabSelector: function() {
                return TabSelector;
            },
            backButtonBar: function () {
                return BackButtonBar;
            },
        },
        loyalty: {
            yourNextRewardCard: function () {
                return YourNextRewardCard;
            },
            chooseNextRewardComponent: function () {
                return ChooseNextRewardComponent;
            },
        },
        menu: {
            promoItem: require('./dist/components/menu/promoItem'),
            menuItem: require('./dist/components/menu/menuItem')
        },
        modals: {
            replaceCardModal: require('./dist/components/modals/replaceCardModal'),
            addCardModal: require('./dist/components/modals/addCardModal'),
            removeCardModal: require('./dist/components/modals/removeCardModal')
        },
        payments: {
            PaymentIFrameHost: require('./dist/components/payments/PaymentIFrameHost')
        },
        iconButton: require('./dist/components/iconButton.js'),
        searchBar: function () {
            return require('./dist/components/SearchBar').default;
        },
        card: function () {
            return require('./dist/components/Card').default;
        },
        textField: function () {
            return require('./dist/components/TextField').default;
        }
    },
    models: {
        menuModel: require('./dist/models/menuModel')
    },
    mixins: {
        ListenerMixin: ListenerMixin
    },
    serviceClients: {
        locationServiceClient: locationServiceClient,
        loginServiceClient: loginServiceClient,
        logoutServiceClient: logoutServiceClient,
        changePasswordServiceClient: require('./dist/service_clients/changePasswordServiceClient'),
        createProfileServiceClient: require('./dist/service_clients/createProfileServiceClient'),
        menuServiceClient: menuServiceClient,
        menuFavoriteServiceClient: menuFavoriteServiceClient,
        favoriteLocationServiceClient: require('./dist/service_clients/favoriteLocationServiceClient'),
        favoriteItemsServiceClient: require('./dist/service_clients/favoriteItemsServiceClient'),
        favoriteMealsServiceClient: require('./dist/service_clients/favoriteMealsServiceClient'),
        profileServiceClient: profileServiceClient,
        orderServiceClient: orderServiceClient,
        offersServiceClient: offersServiceClient,
        paymentServiceClient: paymentServiceClient,
        passcodeServiceClient: passcodeServiceClient,
        bootstrapProfileClient: bootstrapProfileClient,
        careerJobServiceClient: careerJobServiceClient,
        nutritionServiceClient: nutritionServiceClient,
        loyaltyServiceClient: loyaltyServiceClient,
        transactionHistory: transactionHistoryServiceClient,
        autoReloadClient: autoReloadClient,
        universalAnalyticsServiceClient: googleAnalyticsMeasurementProtocolServiceClient,
        emailVerificationServiceClient: emailVerificationServiceClient,
        giftCardServiceClient: giftCardServiceClient
    },
    storage: storage,
    lib: {
        BaseEventEmitter: require('./dist/lib/BaseEventEmitter'),
        Action: require('./dist/lib/Action'),
        UrlUtility: require('./dist/lib/UrlUtility'),
        mappers: {
            favoriteMeal: require('./dist/lib/mappers/favoriteMeal'),
            location: require('./dist/lib/mappers/location')
        },
        ThreatMetrix: require('./dist/lib/ThreatMetrix'),
        kount: require('./dist/lib/kount'),
        flux: {
            dispatcher: dispatcher,
            store: store
        },
        geo: require('./dist/lib/geo'),
        mobileBrowserHelper: require('./dist/lib/mobileBrowserHelper'),
        analytics: require('./dist/lib/analytics/Analytics'),
        ReactRouterHelper: require('./dist/lib/ReactRouterHelper'),
        ReactErrorHandlerWrapper: require('./dist/lib/reactErrorHandlingWrapper'),
        userHelpers: require('./dist/lib/UserHelpers.js'),
        ADAHelpers: require('./dist/lib/ADAHelpers.js'),
        linter: require('./dist/lib/linter'),
        sessionUtility: require('./dist/lib/sessionUtility'),
        elkLogLib: require('./dist/lib/elk'),
        StringHelper: require('./dist/lib/StringHelper'),
        localizationHelper: require('./dist/lib/localizationHelper'),
    },
    elkSessionLogger: require('./dist/lib/elk/local.session.logger').default,
    environment: require('./dist/lib/environments'),
    getConfiguration: function() {
        return require('./dist/lib/config');
    },
    localization: {
        LocalizationManager: require('./dist/localization/LocalizationManager'),
        LocalizationMixin: require('./dist/localization/LocalizationMixin'),
        CommonWebLocalization: require('./dist/localization/commonWebLocalization'),
        enUS: require('./dist/localization/en_US'),
        esUS: require('./dist/localization/es_US'),
        enCA: require('./dist/localization/en_CA'),
        frCA: require('./dist/localization/fr_CA')
    },
    data: {
        locale: require('./dist/lib/data/locale')
    },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/index.js
// module id = 186
// module chunks = 0